// components/SafeContent.js
import React from 'react';
import DOMPurify from 'dompurify';

const SafeContent = ({ htmlContent }) => {
    // Nettoyage du contenu HTML avec DOMPurify
    const cleanHTML = DOMPurify.sanitize(htmlContent);

    return <div dangerouslySetInnerHTML={{ __html: cleanHTML }} />;
};

export default SafeContent;
